import * as BRANCH_TYPES from './actionTypes';
import { BranchActions, IBranchState } from './types';

export const initialState: IBranchState = {
  branchList: [],
  total: 0,
  loading: false,
  error: null
};

const branchReducer = (state = initialState, action = {} as BranchActions): IBranchState => {
  switch (action.type) {
    case BRANCH_TYPES.FETCH_BRANCH_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case BRANCH_TYPES.FETCH_BRANCH_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        branchList: action.payload.branchList,
        total: action.payload.total,
        error: null
      };
    case BRANCH_TYPES.FETCH_BRANCH_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case BRANCH_TYPES.CLEAR_BRANCH_LIST:
      return {
        ...state,
        branchList: [],
        total: 0,
        error: null
      };
    default:
      return state;
  }
};

export default branchReducer;
